

































import Vue from 'vue';
import { ISlide } from '../../../../common/interfaces/frontpage.interface';
import { IStyleObject } from '../../../../common/interfaces/index.interface';
import ArrowIconNew from '@/components/icons/ArrowIconNew.vue';

export default Vue.extend({
  name: `SlideContent`,
  components: { ArrowIconNew },
  computed: {
    backgroundImageObject(): IStyleObject {
      return {
        backgroundImage: `url('${this.slideDataObject.imageUrl}')`,
      };
    },
    colorObject(): IStyleObject {
      return {
        backgroundColor: this.slideDataObject.backgroundColor,
        color: this.slideDataObject.textColor,
      };
    },
  },
  props: {
    slideDataObject: {
      required: true,
      type: Object as () => ISlide,
    },
  },
});
